import { useMemo } from 'react'

import { useScreen } from '@/store/screen'

export const useObjectives = (imageWidth: number) => {
  const { windowSize } = useScreen()

  const fontSizesByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        title: 'h3' as const,
        description: 'b2' as const,
      },
      700: {
        title: 'b1' as const,
        description: 'b3' as const,
      },
    }
    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizesByScreenSize[1440]
    if (width <= 700) return fontSizesByScreenSize[700]
    return fontSizesByScreenSize[1440]
  }, [width, fontSizesByScreenSize])

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 2500, min: 1280 },
      items: imageWidth > 250 ? 2 : 5,
    },
    desktop: {
      breakpoint: { max: 1280, min: 768 },
      items: imageWidth > 250 ? 2 : 3,
    },
    tablet: {
      breakpoint: { max: 768, min: 480 },
      items: imageWidth > 250 ? 1 : 2,
    },
    mobile: {
      breakpoint: { max: 480, min: 0 },
      items: 1,
    },
  }

  return {
    fontSizes,
    responsive,
  }
}
